import { routing } from '@utils/routing'

export const createGuideUrl = (slug: string, personaParameter: string | undefined) => {
  const url = new URL(`${routing.external.guides}${slug}`)

  if (personaParameter) {
    url.searchParams.set('persona', personaParameter)
  }

  url.searchParams.set('embedded', 'true')

  return url.toString()
}
